import { WorkOrderStatus } from "../constants/WorkOrderStatuses";
import { ConfirmDialogData } from "../models/ConfirmDialogData";
import BaseController from "../pages/sharedControllers/BaseController";
import GetWorkOrderChangeStatusQuestion from "./GetWorkOrderChangeStatusData";

export async function ChangeWorkOrderStatus(
  controller: BaseController,
  newStatus: WorkOrderStatus,
  actionAfterChange?: () => void
) {
  const confirmDialogData: ConfirmDialogData =
    GetWorkOrderChangeStatusQuestion(newStatus);

  const statusesThatRequireComment = await controller.get<WorkOrderStatus[]>(
    "api/WorkOrder/GetWorkOrderStatusesThatRequireComment"
  );

  const requiresComment: boolean =
    statusesThatRequireComment.includes(newStatus);

  controller.openSimpleDialog({
    title: confirmDialogData.title,
    message: confirmDialogData.message,
    state: confirmDialogData.dialogState,
    type: "Confirm",
    confirmWithComment: requiresComment,
    confirmAction: async (comment?: string) => {
      await controller.saveDataAndShowMessage(
        "api/WorkOrder/ChangeWorkOrderStatus",
        {
          params: {
            workOrderId: controller.routeParams.workOrderId,
            newStatus: newStatus,
            comment: comment,
          },
        }
      );
      if (actionAfterChange) actionAfterChange();
    },
  });
}
